/* eslint-disable no-param-reassign */
/* eslint-disable max-len */
import produce from "immer";
import {
  SEARCH_STATIONS_REQUEST,
  SEARCH_STATIONS_SUCCESS,
  SEARCH_STATIONS_FAILURE,
  GET_STATIONS_REQUEST,
  GET_STATIONS_SUCCESS,
  GET_STATIONS_FAILURE,
  ADD_STATION_REQUEST,
  ADD_STATION_SUCCESS,
  ADD_STATION_FAILURE,
  GET_STATION_REQUEST,
  GET_STATION_SUCCESS,
  GET_STATION_FAILURE,
  GET_STATIONFUNCTION_REQUEST,
  GET_STATIONFUNCTION_SUCCESS,
  GET_STATIONFUNCTION_FAILURE,
  DELETE_STATION_REQUEST,
  DELETE_STATION_SUCCESS,
  DELETE_STATION_FAILURE,
  UPDATE_STATION_REQUEST,
  UPDATE_STATION_SUCCESS,
  UPDATE_STATION_FAILURE,
  GET_STATIONCANPICK_FAILURE,
  GET_STATIONCANPICK_REQUEST,
  GET_STATIONCANPICK_SUCCESS
} from "src/actions/stationActions";

const initialState = {
  stations: [],
  station: {},
  stationFunctions: [],
  stationCanPicks: [],
  total: 0,
  loadingGetStations: false,
  loadingCreateStation: false,
  loadingUpdateStation: false,
  loadingGetStation: false,
  loadingDeleteStation: false
};

const stationReducer = (state = initialState, action) => {
  switch (action.type) {
    case SEARCH_STATIONS_REQUEST: {
      return produce(state, (draft) => {
        draft.stations = [];
        draft.loadingGetStations = true;
      });
    }

    case SEARCH_STATIONS_SUCCESS: {
      const {response, total} = action.payload;
      return produce(state, (draft) => {
        draft.stations = response;
        draft.loadingGetStations = false;
        draft.total = total;
      });
    }

    case SEARCH_STATIONS_FAILURE: {
      return produce(state, (draft) => {
        draft.loadingGetStations = false;
      });
    }

    case GET_STATIONS_REQUEST: {
      return produce(state, (draft) => {
        draft.stations = [];
        draft.loadingGetStations = true;
      });
    }

    case GET_STATIONS_SUCCESS: {
      const {response} = action.payload;
      return produce(state, (draft) => {
        draft.stations = response;
        draft.loadingGetStations = false;
      });
    }

    case GET_STATIONS_FAILURE: {
      return produce(state, (draft) => {
        draft.loadingGetStations = false;
      });
    }

    case ADD_STATION_REQUEST: {
      return produce(state, (draft) => {
        draft.loadingCreateStation = true;
      });
    }

    case ADD_STATION_SUCCESS: {
      const {response} = action.payload;
      return produce(state, (draft) => {
        draft.stations = draft.stations.concat(response);
        draft.loadingCreateStation = false;
      });
    }

    case ADD_STATION_FAILURE: {
      return produce(state, (draft) => {
        draft.loadingCreateStation = false;
      });
    }

    case GET_STATION_REQUEST: {
      return produce(state, (draft) => {
        draft.station = {};
        draft.loadingGetStation = true;
      });
    }

    case GET_STATION_SUCCESS: {
      const {response} = action.payload;
      return produce(state, (draft) => {
        draft.station = response;
        draft.loadingGetStation = false;
      });
    }

    case GET_STATION_FAILURE: {
      return produce(state, (draft) => {
        draft.loadingGetStation = false;
      });
    }

    case GET_STATIONFUNCTION_REQUEST: {
      return produce(state, (draft) => {
        draft.stationFunctions = [];
      });
    }

    case GET_STATIONFUNCTION_SUCCESS: {
      const {response} = action.payload;
      return produce(state, (draft) => {
        draft.stationFunctions = response;
      });
    }

    case GET_STATIONFUNCTION_FAILURE: {
      return produce(state, (draft) => {
        // error
      });
    }

    case DELETE_STATION_REQUEST: {
      return produce(state, (draft) => {
        draft.stationFunctions = [];
      });
    }

    case DELETE_STATION_SUCCESS: {
      const {station} = action.payload;

      return produce(state, (draft) => {
        const {stations} = draft;
        let filteredStation;
        if (typeof station === "object") {
          filteredStation = stations.filter((item) => item.id !== station.id);
        } else {
          filteredStation = stations.filter((item) => item.id !== station);
        }

        draft.stations = filteredStation;
      });
    }

    case DELETE_STATION_FAILURE: {
      return produce(state, (draft) => {
        // error
      });
    }

    case UPDATE_STATION_REQUEST: {
      return produce(state, (draft) => {
        draft.loadingUpdateStation = true;
      });
    }

    case UPDATE_STATION_SUCCESS: {
      return produce(state, (draft) => {
        draft.loadingUpdateStation = false;
      });
    }

    case UPDATE_STATION_FAILURE: {
      return produce(state, (draft) => {
        draft.loadingUpdateStation = false;
      });
    }

    case GET_STATIONCANPICK_REQUEST: {
      return produce(state, (draft) => {
        draft.stationCanPicks = [];
      });
    }

    case GET_STATIONCANPICK_SUCCESS: {
      const {response} = action.payload;
      return produce(state, (draft) => {
        draft.stationCanPicks = response;
      });
    }

    case GET_STATIONCANPICK_FAILURE: {
      return produce(state, (draft) => {});
    }

    default: {
      return state;
    }
  }
};

export default stationReducer;
